import { bindActionCreators } from 'redux'
import { AddCard } from '@piconetworks/cards'
import withInjection from '@piconetworks/with-injection'

import { colors } from '@piconetworks/functions'

import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Arbiter from 'common/modules/arbiter'
import Wizard from 'common/modules/wizard'
import Payment from 'common/modules/payment'
import WizardRedux, { WizardLoading } from 'common/pkgs/WizardRedux'
import xFrame from 'common/xFrame'

import { paymentMethods } from 'common/modules/selectors'

const mapStateToProps = (state, props) => {
    const { router, history } = props
    const { wizard } = state
    const linkColor = Loader.selectors.linkColor(state)

    const guestLoader = state.loader.guest
    const userLoader = state.loader.user
    const scopedLoader = userLoader || guestLoader
    const thisWizard = Wizard.selectors.thisWizard({ state, router })
    const userVerified = Loader.selectors.userVerified(state)

    const queryForExternalWizard = thisWizard?.submit?.payload?.url?.query

    return {
        ...props,
        payment: state.payment,
        loader: Loader.selectors.loader(state),
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        getTiersSorted: (scope) => Loader.selectors.tiersSorted(state, scope),
        getIsPledge: (scope) => Loader.selectors.isPledge(state, scope),
        thisWizard,
        wizard,
        isTrial: wizard.previousWizardPayload
            ? wizard.previousWizardPayload.isTrial
            : false,
        contrastColor: colors.getContrastColor(linkColor),
        guestLoader,
        userLoader,
        scopedLoader,
        paymentMethods: paymentMethods(state),
        publisherId: Loader.selectors.publisherId(state),
        updateLoader: Loader.creators.updateLoader,
        WizardRedux,
        WizardLoading,
        userVerified,
        onBackButtonClick: (closeCards = () => {}) => {
            if (queryForExternalWizard) {
                router.replace({
                    pathname: '/select-plan',
                    query: queryForExternalWizard,
                }, {
                    pathname: '/select-plan',
                    query: queryForExternalWizard,
                })
            } else if (thisWizard) {
                history.goBack()
            } else if (userVerified) {
                router.replace({
                    pathname: '/cards/select',
                }, {
                    pathname: '/cards/select',
                })
            } else {
                closeCards()
            }
        },
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        selectPaymentMethod: Payment.creators.selectPaymentMethod,
    }, dispatch),
    dispatch,
    addPaymentMethod: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Payment.creators.addPaymentMethod,
        dispatch,
    }),
    sendExternalLink: (payload) => dispatch(Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Arbiter.creators.sendExternalLink({
                payload,
            }),
        },
    })),
    onFormReset: () => {
        dispatch(Payment.creators.initialize())
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onBackButtonClick: () => {
        stateProps.onBackButtonClick(() => {
            xFrame.prompt.showMenu({
                dispatch: dispatchProps.dispatch,
            })
        })
    },
})

const InjectedAddCard = withInjection(AddCard, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedAddCard
